import React from 'react';
import { string } from 'prop-types';
import { CondensedLarge, Gutter, NoteIcon, SmallHeader } from '@axiom/ui';

import { formatDataTestId } from '../../utils/data-test-util';

import { EmptyDescriptionWrapper } from './EmptyDescriptionStyles';

const EmptyDescription = ({ header, body }) => (
  <EmptyDescriptionWrapper data-test={formatDataTestId('EmptyDescription')}>
    <NoteIcon />
    <Gutter top="0.5rem" bottom="0.25rem">
      <SmallHeader>{header}</SmallHeader>
    </Gutter>
    <CondensedLarge>{body}</CondensedLarge>
  </EmptyDescriptionWrapper>
);

EmptyDescription.propTypes = {
  body: string,
  header: string,
};

EmptyDescription.defaultProps = {
  header: 'No Description',
  body: 'Click the edit icon to enter a description',
};

export default EmptyDescription;
